import React from "react";
import Bag from "../../assets/icons/BugSale";
import Database from "../../assets/icons/Database";
import DatabaseUserPage from "../DatabaseUserPage";
import DatabaseAdminPage from "../DatabaseAdminPage";
import ProductSettingPage from "../ProductSettingPage";
import Coupon from "../../assets/icons/Coupon";
import CouponSettingPage from "../CouponSettingPage";
import { Picklist, Option } from "react-rainbow-components";
import { RiUserSearchFill, RiAdminFill } from "react-icons/ri";
import { FaShoppingBasket } from "react-icons/fa";
import { RiCoupon3Fill } from "react-icons/ri";

import {
  ContainerCard,
  Containers,
  GroupCard,
  MyCard,
  SelectContainer,
} from "./index.style";
import useWindowDimensions from "../../functions/windows";

type StateContent = "databaseUser" | "databaseAdmin" | "promotion" | "coupon";
interface IStateContent {
  state: StateContent;
  title: string;
  icon: React.ReactNode;
  subTitle: string[];
  iconMobile: React.ReactNode;
}
const stateContent: IStateContent[] = [
  {
    state: "promotion",
    title: "จัดการโปรโมชั่นสินค้า",
    icon: <Bag />,
    subTitle: ["ระบบจัดการสินค้า", "และโปรโมชัน"],
    iconMobile: <FaShoppingBasket size="1rem" />,
  },
  {
    state: "coupon",
    title: "จัดการคูปอง",
    icon: <Coupon />,
    subTitle: ["เพิ่มคูปอง และ", "ผู้มีสิทธิ์ใช้คูปอง"],
    iconMobile: <RiCoupon3Fill size="1rem" />,
  },
  {
    state: "databaseAdmin",
    title: "จัดการฐานข้อมูลผู้ดูแล",
    icon: <Database />,
    subTitle: ["ข้อมูลผู้ดูแลระบบ", "หมอ, ฝ่ายขาย"],
    iconMobile: <RiAdminFill size="1rem" />,
  },
  {
    state: "databaseUser",
    title: "จัดการฐานข้อมูลลูกค้า",
    icon: <Database />,
    subTitle: ["ข้อมูลลูกค้าในระบบ", "และสัตว์เลี้ยง"],
    iconMobile: <RiUserSearchFill size="1rem" />,
  },
];
function SettingPage() {
  const [content, setContent] = React.useState<StateContent>("promotion");
  const { width } = useWindowDimensions();
  return (
    <Containers>
      {width > 767 ? (
        <GroupCard className="group-card">
          {stateContent.map((item) => (
            <ContainerCard
              key={`${item.state}-container`}
              onClick={() => setContent(item.state)}
            >
              <MyCard className="group-card">
                {item.icon}
                <div>
                  <h6>{item.title}</h6>
                  {item.subTitle.map((sub,index) => (
                    <p key={index}>{sub}</p>
                  ))}
                </div>
              </MyCard>
            </ContainerCard>
          ))}
        </GroupCard>
      ) : (
        <SelectContainer>
          <Picklist
            id="picklist-3"
            placeholder="Choose Building"
            onChange={(value) => setContent(value.value)}
            value={{
              label: stateContent.find((item) => item.state === content)?.title,
              value: content,
              name: content,
              icon: stateContent.find((item) => item.state === content)
                ?.iconMobile,
            }}
            hideLabel
          >
            {stateContent.map((item) => (
              <Option
                key={`${item.state}-option`}
                name={item.state}
                label={item.title}
                value={item.state}
                icon={item.iconMobile}
              />
            ))}
          </Picklist>
        </SelectContainer>
      )}
      <MyCard className="content">
        {content === "promotion" ? (
          <ProductSettingPage />
        ) : content === "databaseAdmin" ? (
          <DatabaseAdminPage />
        ) : content === "coupon" ? (
          <CouponSettingPage />
        ) : (
          <DatabaseUserPage />
        )}
      </MyCard>
    </Containers>
  );
}

export default SettingPage;
